module.exports = __webpack_public_path__ + "img/defaultProductIco.c60754be.png";